import { graphql } from 'gql';

export const getBimWorkOrderActsKc2List = graphql(`
    query bimWorkOrderActsKC2(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $groupType: BimActKC2GroupTypeEnum
        $where: BimActKC2ListItemDataFilterInput
        $order: [BimActKC2ListItemDataSortInput!]
    ) {
        bimWorkOrderActsKC2(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            groupType: $groupType
            where: $where
            order: $order
        ) {
            items {
                actDate
                actId
                actMonth
                actYear
                chapter
                chapterTip
                constructionType {
                    id
                    code
                    name
                    fullName
                    shortName
                    contractFileName
                    catalogId
                    createdAt
                    uniqueId
                }
                constructionTypeId
                costGroup
                costWithoutTax
                finishDate
                groupCostWithoutTax
                groupCount
                groupId
                groupName
                groupUniqueId
                isIncluded
                number
                startDate
                status
                statusTip
                workOrderObjectId
                workOrderObjectName
                workOrderPriceCode
                workOrderPriceName
                isInactive
                isCorrection
                fullNumber
                correctionNumber
                correctionDate
            }
            totalCount
        }
    }
`);
export const bimWorkOrderActsKC2SelectionListGql = graphql(`
    query bimWorkOrderActsKC2SelectionList(
        $workOrderId: Long!
        $actKC2GroupId: Long
        $where: BimActKC2SelectionDataFilterInput
        $order: [BimActKC2SelectionDataSortInput!]
    ) {
        bimWorkOrderActsKC2SelectionList(
            workOrderId: $workOrderId
            actKC2GroupId: $actKC2GroupId
            where: $where
            order: $order
        ) {
            totalCount
            items {
                groupId
                groupName
                actId
                number
                actDate
                startDate
                finishDate
                costGroup
                constructionType {
                    id
                    code
                    name
                    fullName
                    shortName
                    contractFileName
                    catalogId
                    createdAt
                    uniqueId
                }
                workOrderObjectName
                costWithoutTax
                isIncluded
                chapter
                chapterTip
                status
                statusTip
                workOrderPriceCode
                workOrderPriceName
                isCorrection
                isInactive
                correctionNumber
                fullNumber
                correctionDate
            }
        }
    }
`);

export const bimCreateWorkOrderActsKC2GroupGql = graphql(`
    mutation bimCreateWorkOrderActsKC2Group($workOrderId: Long!, $input: BimActKC2GroupInput!) {
        bimCreateWorkOrderActsKC2Group(workOrderId: $workOrderId, input: $input) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderActsKC2GroupGql = graphql(`
    mutation bimUpdateWorkOrderActsKC2Group($actKC2GroupId: Long!, $input: BimActKC2GroupInput!) {
        bimUpdateWorkOrderActsKC2Group(actKC2GroupId: $actKC2GroupId, input: $input) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderActsKC2GroupGql = graphql(`
    mutation bimRemoveWorkOrderActsKC2Group($actKC2GroupId: Long!) {
        bimRemoveWorkOrderActsKC2Group(actKC2GroupId: $actKC2GroupId) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimActKC2GroupNumberFilterGql = graphql(`
    query bimActKC2GroupNumberFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        bimActKC2GroupNumberFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupDateFilterGql = graphql(`
    query bimActKC2GroupDateFilter($workOrderId: Long!, $where: FilterValueOfNullableOfDateTimeFilterInput) {
        bimActKC2GroupDateFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupCostGroupFilterGql = graphql(`
    query bimActKC2GroupCostGroupFilter($workOrderId: Long!, $where: FilterValueOfCostGroupEnumFilterInput) {
        bimActKC2GroupCostGroupFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupConstructionTypeFilterGql = graphql(`
    query bimActKC2GroupConstructionTypeFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        bimActKC2GroupConstructionTypeFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupObjectFilterGql = graphql(`
    query bimActKC2GroupObjectFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        bimActKC2GroupObjectFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupChapterFilterGql = graphql(`
    query bimActKC2GroupChapterFilter($workOrderId: Long!, $where: FilterValueOfNullableOfBimChapterEnumFilterInput) {
        bimActKC2GroupChapterFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const bimActKC2GroupPriceCodeFilterGql = graphql(`
    query bimActKC2GroupWorkOrderPriceCodeFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        bimActKC2GroupWorkOrderPriceCodeFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const bimIsUniqueActKC2GroupNameGql = graphql(`
    query bimIsUniqueActKC2GroupName($workOrderId: Long!, $groupName: String!, $actKC2GroupId: Long) {
        bimIsUniqueActKC2GroupName(workOrderId: $workOrderId, groupName: $groupName, actKC2GroupId: $actKC2GroupId) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
